import { render, staticRenderFns } from "./subject-create.vue?vue&type=template&id=29ae080a&"
import script from "./subject-create.vue?vue&type=script&lang=js&"
export * from "./subject-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports